import { FeaturesProvider } from '../hooks/useFeatures';
import OeffentlicherRahmen from './OeffentlicherRahmen';
import SeitenGrenze from './SeitenGrenze';

/**
 * Die öffentlichen Bereichsseiten für Gäste (Community-Backtests, Architekten,
 * Investorprofil): der `OeffentlicherRahmen` mit Reiterleiste, die Polsterung
 * des Bereichs und die Fehlergrenze der Seite.
 *
 * Eine Komponente, zwei Wege: `PublicLayoutRoute` in `App.jsx` rendert sie für
 * Gäste der Single-Page-App, `OeffentlicheSeite` für dieselben Seiten auf dem
 * Server (Next.js-Phase 2). Stünde das in beiden, sähen dieselbe Seite als
 * Server-Seite und als App-Seite verschieden aus.
 *
 * Der `FeaturesProvider` gehört dazu: die Seiten rendern Bausteine mit
 * Tarif-Sperren (`ExportDropdown` in den Diagrammen). Ohne Provider meldete
 * `useFeatures()` beim ersten Laden der Community-Backtests einen Fehler.
 * Ohne Sitzung fragt der Provider nicht nach — ein Gast hat keine Merkmale,
 * und genau das ist dann sein Zustand.
 */
export default function OeffentlicherBereich({ children }) {
  return (
    <FeaturesProvider>
      <OeffentlicherRahmen reiter inhaltStyle={{ padding: '24px', maxWidth: '1400px', margin: '0 auto' }}>
        <SeitenGrenze>{children}</SeitenGrenze>
      </OeffentlicherRahmen>
    </FeaturesProvider>
  );
}
